export const getCorrespondingImage = ({ prn, images }) => {
  const normalizedPrn = prn && prn.split(':').join('-');

  return images.find(
    image => image?.childImageSharp?.fluid?.src.includes(normalizedPrn) && image
  );
};
